import React from "react";
import Dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_EVENT,
  UPDATE_EVENT,
  CREATE_EVENT,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { VoAuth } from "@vocollege/app";
import Utils from "services/Utils";

export default function EventEdit() {
  const now = Dayjs();
  const router = useParams<any>();
  const navigate = useNavigate();

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      title: "",
      body: "",
      status: 0,
      author: null,
      allday: false,
      start_date: now.minute(60).format("YYYY-MM-DD"),
      start_time: now.minute(60).format("HH:mm") + ":00",
      end_date: now.minute(120).format("YYYY-MM-DD"),
      end_time: now.minute(120).format("HH:mm") + ":00",
      location: "",
      tags: [],
      attachments: [],
    };

    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  // Methods.

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/events");
    }
  };

  return (
    <Layout>
      <Form
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                  md: 5,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
              {
                name: "tags",
                label: I18n.get.tag.labels.tags,
                type: "tags_field",
                grid: {
                  xs: 12,
                  md: 7,
                },
                params: {
                  dialog: {
                    types: ["tag"],
                    addNew: true,
                  },
                },
              },
              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                required: false,
                grid: {
                  xs: 12,
                },
              },
            ],
          },

          {
            key: "event",
            label: I18n.get.event.label,
            fields: [
              {
                name: "allday",
                label: I18n.get.form.labels.allday,
                type: "switch",
                grid: {
                  xs: 12,
                  md: 4,
                },
                params: {
                  boolean: true,
                },
              },
              {
                name: "location",
                label: I18n.get.event.labels.location,
                type: "text",
                grid: {
                  xs: 12,
                  md: 8,
                },
              },
              {
                name: "start_date",
                label: I18n.get.form.labels.startdate,
                type: "date_field",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "start_time",
                label: I18n.get.form.labels.starttime,
                type: "time_field",
                grid: {
                  xs: 12,
                  md: 3,
                },
                params: {
                  dependency: {
                    allday: {
                      value: true,
                      visibility: false,
                    },
                  },
                },
              },
              {
                name: "end_date",
                label: I18n.get.form.labels.enddate,
                type: "date_field",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "end_time",
                label: I18n.get.form.labels.endtime,
                type: "time_field",
                grid: {
                  xs: 12,
                  md: 3,
                },
                params: {
                  dependency: {
                    allday: {
                      value: true,
                      visibility: false,
                    },
                  },
                },
              },
            ],
          },
          {
            key: "attachments",
            label: I18n.get.misc.attachments,
            fields: [
              {
                name: "attachments",
                label: I18n.get.misc.attachments,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  contentType: "file",
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.event.labels.createEvent,
          created: I18n.get.event.messages.eventSaved,
          updated: I18n.get.event.messages.eventSaved,
          deleted: I18n.get.event.messages.eventDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "event",
          get: GET_EVENT,
          create: CREATE_EVENT,
          update: UPDATE_EVENT,
        }}
        // paths={{
        //   back: "/content/events",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
